import * as types from './Types';

const url = '/api/movimentacao-tributo';

export const findRenunciaReceitas = params => ({ fetch }) => {
  return {
    type: types.FIND_RENUNCIA_RECEITAS,
    payload: {
      promise: fetch(`${url}?${params}`)
    }
  };
};
